<template>
<div style="height: 100%;">
    <div class="home-main">
        <div class="home-logo">
            <h1 title="Arivo Tyre">
                <img src="../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42">
            </h1>
            <h2 title="HOME"><img src="../common/images/top/home.png" alt="HOME" width="229" height="219"></h2>
        </div>
        <div class="home-nav">
            <div class="home-nav--ban">
                <img src="../common/images/top/slogan.png" alt="Safety, Quality and Performance go together !"
                        width="1062" height="61">
            </div>
            <ul>
                <li><strong><a href="/company" v-bind:title="$t('tlCompany')">{{$t('tlCompany')}}</a></strong>
                    <span><a href="/company/aboutus" v-bind:title="$t('tlAboutUs')">{{$t('tlAboutUs')}}</a></span>
                    <span><a href="/company/culture" v-bind:title="$t('tlCulture')">{{$t('tlCulture')}}</a></span>
                    <span><a href="/company/rnd" v-bind:title="$t('tlRND')">{{$t('tlRND')}}</a></span></li>

                <li><strong><a href="/products" v-bind:title="$t('tlProductCenter')">{{$t('tlProductCenter')}}</a></strong>
                    <span v-for="item in series">
                        <a v-bind:href="'/products?selected='+item.id+'&series='+item.name" v-bind:title="item.name">{{item.name}}</a>
                    </span></li>

                <li><strong><a href="/service" v-bind:title="$t('tlService')">{{$t('tlService')}}</a></strong>
                    <span><a href="/service/knowledge" v-bind:title="$t('tlTyreKnowledge')">{{$t('tlTyreKnowledge')}}</a></span>
                    <span><a href="/service/maintenance" v-bind:title="$t('tlMaintenance')">{{$t('tlMaintenance')}}</a></span>
                    <span><a href="/service/rotation" v-bind:title="$t('tlRotation')">{{$t('tlRotation')}}</a></span>
                    <span><a href="/service/driving" v-bind:title="$t('tlDrivingTips')">{{$t('tlDrivingTips')}}</a></span>
                    <span><a href="/service/sidewall" v-bind:title="$t('tlSidewallInfo')">{{$t('tlSidewallInfo')}}</a></span>
                    <span><a href="/service/warranty" v-bind:title="$t('tlWarranty')">{{$t('tlWarranty')}}</a></span>
                    <span><a href="/service/download" v-bind:title="$t('tlDownload')">{{$t('tlDownload')}}</a></span></li>

                <li><strong><a href="/media" v-bind:title="$t('tlMediaCenter')">{{$t('tlMediaCenter')}}</a></strong>
                    <span><a href="/media/news" v-bind:title="$t('tlNews')">{{$t('tlNews')}}</a></span>
                    <span><a href="/media/video" v-bind:title="$t('tlVideo')">{{$t('tlVideo')}}</a></span>
                    <span><a href="/media/interaction" v-bind:title="$t('tlInteraction')">{{$t('tlInteraction')}}</a></span></li>

                <li><strong><a href="mailto:info@arivotyre.com?subject=Test Email" v-bind:title="$t('tlContact')" class="ico-mail">{{$t('tlContact')}}</a></strong></li>
            </ul>
            <share></share>
        </div>

        <div class="swiper-pagination swiper-pagination-white"></div>
    </div>
    
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :style="{backgroundImage:'url('+bg1+')'}"></div>
        <div class="swiper-slide" :style="{backgroundImage:'url('+bg2+')'}"></div>
        <div class="swiper-slide" :style="{backgroundImage:'url('+bg3+')'}"></div>
      </div>
    </div>
    <div class="footer">
        <language></language>
        <address>Grid Design Tool Version 0.9 Copyright (c) 2008</address>
    </div>
</div>
</template>
<script>
import $ from "jquery";
import Share from "components/common/share";
import Language from "components/common/language";
import _util from "utils";
import productApi from "api/product-api";
import Bg1 from "common/images/top/bg_01.jpg";
import Bg2 from "common/images/top/bg_02.jpg";
import Bg3 from "common/images/top/bg_03.jpg";

import Swiper from "swiper";
export default {
  name: "Home",
  components: {
    Share,
    Language
  },
  data() {
    $(function() {
      $("body").attr("class", "home");
    });

    return {
      series: [],
      bg1: Bg1,
      bg2: Bg2,
      bg3: Bg3
    };
  },
  mounted() {
    var _this = this;
    $(function() {
      _this.getAllSerieses(function(data) {
        _this.series = data;
      });
    });
    var swiper = new Swiper(".swiper-container", {
      spaceBetween: 30,
      effect: "fade",
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  },
  methods: {
    getAllSerieses(callback) {
      productApi.getAllSerieses(
        function(response) {
          callback(response);
        },
        function(error) {}
      );
    }
  }
};
</script>
<style>
@import "../common/css/swiper.css";
</style>



// WEBPACK FOOTER //
// src/components/Home.vue